import React from 'react';

/**
 * Live-Vorschau rechts neben Formularen (README §9: flex 1 1 250px, max 320px).
 * Karte mit Akzent-Ring, darüber das Label mit grünem Punkt.
 */
export function LivePreviewCard({ label = 'Live-Vorschau', children }: { label?: string; children: React.ReactNode }) {
  return (
    <aside className="flex flex-col min-w-0" style={{ flex: '1 1 250px', maxWidth: 320, gap: 10 }} aria-label={label}>
      <span className="flex items-center" style={{ gap: 6, paddingLeft: 4, fontSize: 12, fontWeight: 700, color: 'var(--ink3)' }}>
        <span style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--ok)' }} />
        {label}
      </span>
      <div
        className="flex flex-col"
        style={{ borderRadius: 24, padding: 16, gap: 14, background: 'var(--fill)', boxShadow: 'inset 0 0 0 2px var(--acc), 0 18px 40px -18px var(--shade)' }}
      >
        {children}
      </div>
    </aside>
  );
}
